// EventIntroSection.jsx
import React, { useState } from 'react';
import './EventIntroSection.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';
import ContactModal from '../components/ContactModal';


const EventIntroSection = ({ ticketsRef, galleryRef, experiencesRef, accommodationRef }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  return (
    <section className="event-intro-section" aria-label="Event introduction and navigation">
      {/* Description */}
      <div className="header">
        <p>Join us in embracing tradition, modernity, and eco-consciousness with over 20+ global artists
        set against the breathtaking beauty of Umiam lake</p>
      </div>

      {/* Ticker */}
      <div className="ticker">
  <div className="ticker-content">
    <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
     <button 
       className="ticker-link" 
       onClick={() => setIsContactModalOpen(true)}
       type="button">
      contact us
    </button>
    <span>•</span>
  </div>
</div>

      {/* Contact Modal */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />

      {/* Navigation Links */}
      <div className="links">
        <button className="link-item" onClick={() => scrollToSection(ticketsRef)}>
          <i className="fas fa-ticket-alt"></i> TICKETS
        </button>
        <button className="link-item" onClick={() => scrollToSection(galleryRef)}>
          <i className="fas fa-photo-video"></i> GALLERY
        </button>
        <button className="link-item" onClick={() => scrollToSection(experiencesRef)}>
          <i className="fas fa-map-marked-alt"></i> EXPERIENCES
        </button>
        <button className="link-item" onClick={() => scrollToSection(accommodationRef)}>
    <i className="fas fa-bed"></i> ACCOMMODATION
  </button>
      </div>
    </section>
  );
};

export default EventIntroSection;
